<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/progress" color="error" exact icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">{{user.displayName}}</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12 sm10>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else class="py-3 px-2" row wrap justify-center>
        <v-flex v-if="progress.length == 0" class="py-5" xs12>
          <div class="text-xs-center display-3 grey--text text--lighten-1">
            No Courses
          </div>
        </v-flex>
        <v-flex v-else class="px-2 pb-3" xs12 md10>
          <v-expansion-panel class="elevation-0">
            <template v-for="p, i in progress">
              <v-expansion-panel-content class="mb-3">
                <div slot="header">
                  <div class="title secondary--text">
                    <span><b>{{p.name}}</b></span>
                  </div>
                </div>
                <v-layout row wrap>
                  <v-flex class="pb-1 pl-4" xs12>
                    <div v-if="p.endTime" class="pl-2">
                      <span v-if="courseEnded(p)">Ended</span>
                      <span v-else>Ends</span>
                      <span> on {{(new Date(p.endTime)).toLocaleDateString()}}</span>
                    </div>
                    <div v-else class="pl-2">Not Started</div>
                  </v-flex>
                  <v-flex class="pb-2 pl-4" xs12>
                    <v-btn :to="'/progress/' + user.uid + '/' + p.key" color="primary" depressed small>View</v-btn>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
              <v-divider v-if="i < (progress - 1)" class="my-3"></v-divider>
            </template>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    user: {},
    progress: []
  }),
  computed: {
    now () {
      return this.$store.getters.now
    },
    courseEnded () {
      return (p) => {
        return this.now > p.endTime
      }
    }
  },
  beforeMount () {
    this.load()
  },
  methods: {
    beforeEnter () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (!this.$store.getters.userById(this.$route.params.uid)) {
        appMsg.msg = 'Student not found'
        this.$store.dispatch('showAppMsg', appMsg)
        this.$route.push('/progress')
      }
    },
    load () {
      this.loading = true
      this.beforeEnter()
      this.user = this.$store.getters.userById(this.$route.params.uid)
      this.progress = [...this.$store.getters.progressByStudent(this.user.uid)]
      this.progress.sort((a, b) => {
        if (!a.endTime || !b.endTime) return !a.endTime ? -1 : 1
        else return -1 * (a.endTime - b.endTime) // Sorts in reverse
      })
      this.$store.dispatch('loadTaskProgress', this.user.uid).then(() => {
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/progress/StudentCourseList.vue